import { m as o } from "./index763.mjs";
import "./index762.mjs";
import { __exports as i } from "./index765.mjs";
var r = o, n = i, s = function(f, e, t) {
  return t.get && r(t.get, e, { getter: !0 }), t.set && r(t.set, e, { setter: !0 }), n.f(f, e, t);
};
export {
  s as d
};
